export default __webpack_public_path__ + "static/media/866.a2c68874.svg";